import './styles.css';
import React, { useEffect } from "react";

import parse from 'html-react-parser';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'

import {firebaseApp, analytics} from "../../firebase.js";
import { getDatabase, ref, onValue} from "firebase/database";
import { logEvent } from "firebase/analytics";


// Database config
const db = getDatabase(firebaseApp);
const dbData = ref(db, '0/v2/projects');
onValue(dbData, (snapshot) => { if(snapshot !== null) {initialData = snapshot.val(); } }); 



var initialData = [
    {
        id: "",
        content: "not_loaded",
        image: "",
        languages: ["","",""],
        link: "",
        title: ""
    },
    {
        id: "1",
        content: "",
        image: "",
        languages: ["","",""],
        link: "",
        title: ""
    },
    {
        id: "2",
        content: "",
        image: "",
        languages: ["","",""],
        link: "",
        title: ""
    },
    {
        id: "3",
        content: "",
        image: "",
        languages: ["","",""],
        link: "",
        title: ""
    }
];



//FA
library.add(faArrowUpRightFromSquare); 

function AnimatedCardRender() {
    // Cambios after render (EFECTOS "SECUNDARIOS")
     useEffect(() => {
       document.querySelectorAll(".card.projectCard").forEach((card, i) => {card.setAttribute("id",`card-${i}`);});
       const cards = document.querySelectorAll(".card.projectCard");
       cards.forEach((card, i ) => {
         document.getElementById(card.id).style.animation = `fadeIn .5s ease-in-out ${i/4}s 1 both normal`;
       });
     })
   }

function AnimatedListRender() {
    // Cambios after render (EFECTOS "SECUNDARIOS")
        useEffect(() => {
            const texts = document.querySelectorAll(".lazyList li > span.text");
        texts.forEach((text, i) => {text.setAttribute("id",`lazyList-text-${i}`);});
        texts.forEach((text, i ) => {
            document.getElementById(text.id).style.animation = `fadeIn .5s var(--animation-timing-3) ${i/3}s 1 both normal`;
        });   
        const items = document.querySelectorAll('.lazyList li > span.divider');
        items.forEach((item, i) => {item.setAttribute("id", `lazyList-item-${i}`);});
        items.forEach((item, i) => {
            document.getElementById(item.id).style = `animation: lineGrow 1s linear ${i/3}s 1 both normal;`
        })
        })
    }
 
var image_counter = 0;

function ProjectListPost(props) {
    const data = props.data;
    let total_images = initialData.length - 1;
    // console.log(initialData)
    // console.log(`TOTAL: ${total_images} READY: ${image_counter}`);
    return [
        <article key={props.childKey} className={`card projectCard shadow-green ${props.last && props.index % 2 === 0? "lastOne" : ""} ${props.init? "": "no-anim"}`} >
                <section key={1} className="header">
                
                    {props.index % 2 === 0? 

                    <div key={1} className='card image shadow-green'><div></div><img className={props.init? "" : "hideBehind"}  src={data.image} alt={props.init? data.image : ""} onLoad={image_counter === total_images? (image_counter = 0, props.callback) : (image_counter = image_counter + 1, (() => {}))}  /></div>    

                : null}
                    <div key={2} className="titleContainer">
                        <p key={1} className='hidden-xs title'> <a className={props.init? "" : "hide"} onClick={(u) => {logEvent(analytics, "select_item", {item_list_id: props.index, item_list_name: data.title})}} href={"https://" + data.link} target="_blank" rel="noreferrer">{data.title}<span></span><FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a></p>
                        <ul key={2} className='lazyList projectLang hidden-xs'>
                            {
                                props.init? 
                            data.languages.map((lang, i) => 
                                <li key={i}><span className="text">{lang}</span> <span className='divider'></span></li>
                            ) :
                            ["","",""].map(i => [<li key={i}></li>,<br key={i+1} />] )
                            }
                        </ul>
                       
                    </div>
                    
                    {props.index % 2 !== 0? 
                    <div key={1} className='card image shadow-green'><div></div><img className={props.init? "" : "hideBehind"} src={data.image} alt={props.init? data.image : ""} onLoad={image_counter === total_images? (image_counter = 0, props.callback) : (image_counter = image_counter + 1, (() => {}))}/></div>    

                : null}                
                </section>
                    
                <section key={2} className={`content ${props.index % 2 === 0? 'left': 'right'}`}>
                    <div key={1} className={props.init? "time" : "hide"}><small>{data.timestamp}</small></div>
                    <p  key={2} className='visible-xs title text-center'> <a className={props.init? "" : "hide"} href={"https://" + data.link} target="_blank" rel="noreferrer"  >{data.title}<span></span><FontAwesomeIcon icon={faArrowUpRightFromSquare} /></a></p>

                    <div key={3} className='description'>{props.init? parse(data.content) : ""}</div>
                    <ul key={4} className={props.init? 'customUl visible-xs': "hide"}>
                        { 
                        data.languages.map((lang, i) => 
                                <li key={i}>{lang}</li>
                            )  }
                        </ul>
                </section>

        </article>
        
    ]
}



class ProjectList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pubs: initialData, 
            loaded: false
        }
    }
    isLoaded() {
        this.setState({
            loaded: true
        })
    }
    render() {
               return [
                // <div key={1} className={this.state.loaded? "loaded" : "loaderContainer"}>
                //     <div key={1} className="loader"></div>
                // </div> ,
            <article key={2} className={this.state.loaded? 'card ProjectList' : 'card ProjectList loadingProject'}>
                <main key={1}>
                    { 
                    this.state.pubs.map((pub, i) => 
                    <ProjectListPost 
                    key={i}
                    childKey={i}
                    data={pub} 
                    index={i} 
                    last={i === this.state.pubs.length - 1? true : false}
                    callback={() => this.isLoaded()}
                    init={this.state.loaded? true : false}
                    loaded={this.state.loaded? true : false}
                    ></ProjectListPost>)

                }
                </main>
            </article>
        ]
    }
}


function Projects() {
    AnimatedCardRender();
    AnimatedListRender();
    return [
        <p key={1} className='tabTitle'>My Work </p>,
        <ProjectList key={2}></ProjectList>,
    ];
}

setTimeout(() => {
    if (initialData[0].content === "not_loaded") alert("Something went wrong getting my projects, please try again.") ;
}, 45000);

export default Projects;